import React, { ReactNode, useEffect } from 'react';
import { useMobileVerifyContext } from '../../../../context/MobileVerifyContext';
import { useVerifyLayout } from '../../../../hooks/useVerifyLayout/useVerifyLayout';
import { LoginMethodsEnum } from '../../../../../../../hooks/useLoginTracking/constants';

export const DEFAULT_FINISHING_UP_MESSAGE = 'Finishing up...';

export const DefaultLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {
    data: { isFinished, isJustVerified, isSuccess },
  } = useMobileVerifyContext();
  const { setThemeContext, setLoadingMessage, loadingMessage } = useVerifyLayout();

  const handleFinish = () => {
    const query = new URLSearchParams();
    if (isJustVerified) {
      query.append('alert', 'mobileVerified');
    }

    window.location.href = `${window.location.origin}/account#/${query.toString() ? `?${query}` : ''}`;
  };

  useEffect(() => {
    if (isSuccess && loadingMessage !== DEFAULT_FINISHING_UP_MESSAGE) {
      setLoadingMessage(DEFAULT_FINISHING_UP_MESSAGE);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isFinished) {
      handleFinish();
    }
  }, [isFinished, isJustVerified]);

  useEffect(() => {
    const shouldSkipPhoneVerification = () => {
      const urlParams = new URLSearchParams(window.location.href.split('?')?.[1] ?? '?');
      return (
        urlParams.has('newUser') && urlParams.get('loginMethod')?.toLowerCase() === LoginMethodsEnum.email.toLowerCase()
      );
    };
    setThemeContext(themeContext => ({ ...themeContext, shouldSkipPhoneVerification: shouldSkipPhoneVerification() }));
  }, []);

  return <>{children}</>;
};
